<template>
    <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
            >GEN</v-btn>
        </template>
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ $t('Medicament') }}</v-toolbar-title>
            </v-toolbar>
            <medicament-select
                has-moh-product-id
                v-model="searchByMedicamentCode"
            ></medicament-select>
            <medicament-table
                v-if="productGeneric"
                :product-generic="productGeneric"
                @select="select"
                withBrunvaAccess
                :departmentCode="departmentCode"
            ></medicament-table>
        </v-card>
    </v-dialog>
</template>

<script>
import medicamentSelect from '@/component/medicament-select.vue';
import medicamentTable from '@/component/medicament/table.vue';
import medicamentService from '@/service/medicament-service';

export default {
    components: {
        medicamentSelect,
        medicamentTable,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        departmentCode: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            dialog: false,
            searchByMedicamentCode: null,
            productGeneric: null
        };
    },
    watch: {
        value(val) {
            this.dialog = val;
        },
        dialog(val) {
            this.$emit('input', !!val);
            if (!val) {
                this.searchByMedicamentCode = null;
                this.productGeneric = null;
            }
        },
        async searchByMedicamentCode(value) {
            this.productGeneric = null;
            if (value) {
                let response = await medicamentService.getData(1, 1, { MohProductId: value });
                if (response && response.data && response.data.length > 0) {
                    this.productGeneric = response.data[0].ProductGeneric;
                }
            }
        }
    },
    methods: {
        async select(value) {
            this.$emit('select', value);
            this.dialog = false;
        }
    }
};
</script>